import Asset from '../../../models/Asset';

Vue.component('asset-rate-card', {
    props: ['asset'],
    //language=HTML
    template: `
        <div :class="{'input-group': currentAsset.isSimple, 'text-center': !currentAsset.isSimple}" :key="loadComponent">
            <template v-if="currentAsset.isSimple">
                <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                </div>
                <input type="number" class="form-control table-input" name="rate_card" v-model="currentAsset.rate_card" @change="updateModel" :disabled="currentAsset.busy">
                <small class="help-block invalid-feedback" v-show="currentAsset.errors.has('rate_card')">
                    {{ currentAsset.errors.get('rate_card') }}
                </small>
            </template>
            <template v-else>
                -
            </template>
        </div>
    `,
    data() {
        return {
            currentAsset: null,
        };
    },
    methods: {
        updateModel() {
            const _this = this;
            this.currentAsset.update(['rate_card']).then(() => {
                _this.currentAsset.refresh();
            });
        },
    },
    watch: {
        asset: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.currentAsset = new Asset(newVal);
                this.reloadComponent();
            },
        },
    },
});
